import React, { useEffect, useState, useRef } from 'react';
// @ts-ignore
import { USBButton } from '@usb-shield/components-react';
import Select from '../../components/atoms/Select/Select';
import { getDefaultFilters, getRequirementsRequirements } from './utils';
import USBDatePicker from '@usb-shield/react-date-picker';
import USBSearchInput from '@usb-shield/react-search-input';
const defaultDatePickerErrorMessages = {
  default: 'Enter a valid date.',
  118: 'Enter a valid date.',
  121: "You've reached the character limit. Please try again.",
  130: 'Please enter your date again.',
  201: 'Enter a valid date.',
  202: 'Date should be in the past.',
  203: 'Date should be in the future.',
  204: 'You must be at least 18 years old to apply.',
  205: 'You must be less than 120 years old to apply.',
  224: 'Date is required.',
  228: "That date isn't available. Please try again.",
}

const defaultCalendarSettings = { occurrence: 'past', areBankHolidaysDisabled: false, areWeekendsDisabled: false }
const defaultOptions = {
  parentCompanyName: [],
  dealName: [],
  dealId: [],
  category: [],
  status: [],
  dueDate: {
    dateInput: {
      initValue: '', inputName: 'Due Date'
    }, calendar: { ...defaultCalendarSettings, occurrence: 'past', areBankHolidaysDisabled: false, areWeekendsDisabled: false },
  },
};

function RequirementsFilters({ reqDealId, categories, requirements, reqCategory, filters, setFilters, setRequirements, setStatus, setCurrentPage, setReqDealId, setReqStatus, setReqCategory }) {
  const [options, setOptions] = useState(defaultOptions);
  const [advanceOptions, setAdvanceOptions] = useState(false);
  const [statusValue, setStatusValue] = useState([])

  const statusArr = [
    {
      label: "Show All",
      value: "Status"
    },
    {
      label: "New",
      value: "New",
    },
    {
      label: "Read",
      value: "Read",
    },
    {
      label: "Not Submitted",
      value: "Not Submitted",
    },
    {
      label: "Under Review",
      value: "Under Review",
    },
    {
      label: "Needs Action",
      value: "Needs Action",
    },
    {
      label: "Submitted",
      value: "Submitted",
    },
    {
      label: "Completed",
      value: "Completed",
    }
  ]
  // const statusOption = new Map();
  useEffect(() => {
    const newOptions = (requirements || []).reduce((acc, current) => {
      const {
        category,
        parentCompanyName,
        dealName,
        dealId,
        status,
      } = current;

      return {
        ...acc,
        parentCompanyName: [
          ...acc.parentCompanyName,
          {
            label: parentCompanyName,
            value: parentCompanyName,
          },
        ],
        dealName: [
          ...acc.dealName,
          {
            label: dealName,
            value: dealName,
          },
        ],
        dealId: [
          ...acc.dealId,
          {
            label: dealId,
            value: dealId,
          },
        ],

        category: [
          ...acc.category,
          {
            label: category,
            value: category,
          },
        ],
        status: statusArr
      };
    }, defaultOptions);
    setOptions(newOptions);

    const finalarray = newOptions.status.filter((obj, index) => {
      return index === newOptions.status.findIndex(o => obj.label === o.label);
    })

    setStatusValue(finalarray);

  }, [requirements]);

  let timer;

  function onDealChange(e) {
    const value = e?.target?.value || '';
    setCurrentPage(1);
    setReqDealId(value);
  }

  async function onSelectFilterChange(e, metadata) {
    setCurrentPage(1);
    const { name } = metadata;
    const { value } = e ? e : '';
    // console.log(name , ' ',value);
    if (name == "status") {
      setReqStatus(value)
    }
    if (name == "category") {
      setReqCategory(value)
    }
    await setFilters((previous) => {
      if (e) {
        return { ...previous, [name]: e };
      }
      const { [name]: selectName, ...rest } = previous;
      return rest;
    });

    // sessionStorage.setItem('defaultFilters',JSON.stringify({...filters,[name]:{"label":value,"value":value}}));
  }

  function onClear() {
    // sessionStorage.removeItem('defaultFilters')
    setFilters(getDefaultFilters());
    window.location.href = '/AllRequirements';
  }

  return (
    <section className="filters-container">
      <section className="filters-all">
        {/* parentCompanyName */}

        <section className="filter-item p-t-md">
          <USBSearchInput
            id="cb-table-search"
            name="test-name"
            addClasses="cb-table-search"
            type="search"
            isError={false}
            ariaProps={{
              label: 'Deal ID',
            }}
            // initSearchInputValue={reqDealId}
            placeholder="Deal ID"
            handleChange={onDealChange}
          />

        </section>
        <section className="filter-item p-t-md">
          <Select
            label="Status"
            name="status"
            value={filters.status}
            isClearable={false}
            options={statusArr}
            onChange={onSelectFilterChange}
          ></Select>
        </section>

        <section className="filter-item p-t-md">
          <Select
            label="Document Type"
            name="category"
            value={filters.category}
            isClearable={false}
            options={categories}
            onChange={onSelectFilterChange}
          ></Select>
        </section>

        {/* <section className="filter-item p-t-md"></section> */}
        <section className="filter-item p-t-md">
          <USBButton
            name="clearfilter"
            variant="secondary"
            handleClick={onClear}
            addClasses="clear-button"
          >
            Clear filters
          </USBButton>
        </section>
      </section>
    </section>
  );
}

export default RequirementsFilters;
